var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgPhoneCall(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M2.917 2.333H5.25L6.417 5.25l-1.459.875a6.417 6.417 0 002.917 2.917l.875-1.459 2.917 1.167v2.333c0 .645-.523 1.167-1.167 1.167A9.333 9.333 0 011.75 3.5c0-.644.522-1.167 1.167-1.167M8.75 4.083c.644 0 1.167.523 1.167 1.167M8.75 1.75a3.5 3.5 0 013.5 3.5",
    stroke: "#B4B7BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgPhoneCall;